import React from 'react';
import { Loader2 } from 'lucide-react';
import { primaryButtonClass, secondaryButtonClass, ghostButtonClass, btnMd, btnLg } from '../styles/ui';

const VARIANT_CLASS = {
  primary: primaryButtonClass,
  secondary: secondaryButtonClass,
  ghost: ghostButtonClass,
};

// Reuse the shared size tokens rather than re-declaring padding, so a
// <Button size="md"> is exactly as tall as a raw `${btnPrimary} ${btnMd}`.
const SIZE_CLASS = {
  md: btnMd,
  lg: btnLg,
};

// Shared button primitive covering the brief's full state matrix (hover/
// active/disabled already live in styles/ui.js's className strings; this
// adds the one state those plain classNames can't express — loading, which
// needs a spinner swapped in for the label, not just a CSS tweak).
const Button = ({
  type = 'button',
  variant = 'primary',
  size = 'md',
  loading = false,
  loadingLabel,
  disabled,
  className = '',
  children,
  ...props
}) => (
  <button
    type={type}
    disabled={disabled || loading}
    aria-busy={loading || undefined}
    className={`${VARIANT_CLASS[variant] || VARIANT_CLASS.primary} ${SIZE_CLASS[size] || SIZE_CLASS.md} ${className}`}
    {...props}
  >
    {loading && <Loader2 size={16} className="animate-spin" aria-hidden="true" />}
    {loading ? loadingLabel || children : children}
  </button>
);

export default Button;
